(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mashrabiya-overlay"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__blxMashrabiyaBound) return;
    window.__blxMashrabiyaBound = true;
    var fine = window.matchMedia('(pointer: fine)').matches;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!fine || reduced) return;
    document.addEventListener('pointermove', function (e) {
      var x = (e.clientX / window.innerWidth - 0.5) * 2;
      var y = (e.clientY / window.innerHeight - 0.5) * 2;
      document.documentElement.style.setProperty('--blx-mx', x.toFixed(3));
      document.documentElement.style.setProperty('--blx-my', y.toFixed(3));
    }, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
